import Constants from "./Constants";
import PortugueseStrings from "./PortugueseStrings";
import EnglishStrings from "./EnglishStrings";
import SpanishStrings from "./SpanishStrings";
import DeutschStrings from "./DeutschStrings";

const lang = localStorage.getItem(Constants.LOCAL_STORAGE_KEY);

let Strings = "";

if (lang === Constants.ES_LANG_KEY) {
  Strings = SpanishStrings;
}
else if (lang === Constants.EN_LANG_KEY) {
  Strings = EnglishStrings;
}
else if (lang === Constants.DE_LANG_KEY) {
  Strings = DeutschStrings;
}
else {
  Strings = PortugueseStrings;
}

export default Strings;